import { useState, useEffect, useCallback } from 'react';
import { authHeaders } from '../services/auth';

const WORKER = process.env.REACT_APP_WORKER_URL || 'https://sirus-assistant.andrea-cali27.workers.dev';
const CHECK_MS = 30_000;

// enabled=false (utente non autenticato) salta il check — /api/health richiede auth
// lato backend e altrimenti risponderebbe sempre 401 finché non c'è login.
export function useOnlineStatus(user) {
  const [isOnline, setIsOnline] = useState(true);

  const check = useCallback(async () => {
    try {
      await fetch(`${WORKER}/api/health`, {
        headers:     authHeaders(),
        credentials: 'include',
        signal:      AbortSignal.timeout(5000),
      });
      setIsOnline(true);
    } catch {
      setIsOnline(false);
    }
  }, []);

  useEffect(() => {
    if (!user) return;
    check();
    const iv = setInterval(check, CHECK_MS);
    const goOffline = () => setIsOnline(false);
    window.addEventListener('online',  check);
    window.addEventListener('offline', goOffline);
    return () => {
      clearInterval(iv);
      window.removeEventListener('online',  check);
      window.removeEventListener('offline', goOffline);
    };
  }, [check, user]);

  return isOnline;
}
